
@if (isLoading) {
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
} @else {
    <div class="hospital-journey">
      <!-- Journey Sections -->
      @for (section of journeySections; track section; let i = $index) {
        <app-journey-section
          id="{{ section.sectionId }}"
          [section]="section"
          [isFirstSection]="i === 0"
          [isLastSection]="i === journeySections.length - 1"
          [isAdmin]="true"
          [pageUrl]="this.currentUrl"
          [expanded]="expandedSectionId === section.sectionId"
          [donorLocale]="
            profileInfo?.donor?.locale || profileInfo?.donor?.preferredLocale || ''
          "
          [isComprehensiveQuestionnaireCompleted]="
            isComprehensiveQuestionnaireCompleted
          "
        ></app-journey-section>
      }
    </div>
}
